export type TOfficeTutorial = {
  readonly id: string;
  readonly position: number;
  readonly isActive: boolean;
  readonly title: string;
  readonly parentImages: TOfficeSteps;
  readonly childImages: TOfficeSteps;
};

export type TTutorialStepItem = {
  readonly url: string;
  readonly title: string;
  readonly description: string;
};

export type TOfficeSteps = {
  readonly initialImages: TTutorialStepItem;
  readonly images: TTutorialStepItem[];
};

export enum SlideDirection {
  Initial = 0,
  Next = 1,
  Prev = -1,
}
